import {EntityResourceIds} from '@dms/api/shared';

import {MessageContextResource} from '../types/MessageContextResource';

export const MESSAGE_CONTEXT_RESOURCES: MessageContextResource[] = [
  EntityResourceIds.businessCase,
  EntityResourceIds.customer,
  EntityResourceIds.interest,
  EntityResourceIds.rentalOrder,
  EntityResourceIds.serviceCase,
  EntityResourceIds.serviceOrder,
  EntityResourceIds.vehicle,
  EntityResourceIds.workshopInterest,
];
